import { ShieldCheck } from "lucide-react";

const GOLD = "oklch(0.695 0.105 68)";
const MARINE_DEEP = "oklch(0.115 0.038 243)";

// Badge "MODERATEUR" affiche en haut de l'iframe Jitsi quand le JWT
// indique is_moderator=true (calcule serveur-side dans meetings.py via
// claims.role in {ADMIN, ARBITRE}). Le client ne peut PAS s'auto-
// declarer moderateur -- ce flag est purement informatif cote UI.
//
// Distinction visuelle nette : un arbitre qui rejoint l'audience doit
// savoir immediatement qu'il dispose des prerogatives Jitsi (mute,
// kick, lock room) ; un avocat qui rejoint doit comprendre pourquoi
// il ne voit pas certaines commandes.
export function ModeratorBadge() {
  return (
    <div
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-[10px] uppercase tracking-widest"
      style={{
        background: GOLD,
        color: MARINE_DEEP,
        fontFamily: "'Inter', sans-serif",
        letterSpacing: "0.18em",
        fontWeight: 600,
      }}
    >
      <ShieldCheck size={11} />
      Moderateur
    </div>
  );
}
